import React from 'react';

export default function LabRiskBadge({ label = 'unknown' }) {
  return <span className={`lab-risk-badge lab-risk-${String(label).toLowerCase()}`}>{label}</span>;
}
